// extracted by mini-css-extract-plugin
module.exports = {"AdminActus":"adminActus_AdminActus__3J4x9"};